import { render } from "./TabListingv1.vue?vue&type=template&id=4c78d5de"
import script from "./TabListingv1.vue?vue&type=script&lang=js"
export * from "./TabListingv1.vue?vue&type=script&lang=js"

import "./TabListingv1.vue?vue&type=style&index=0&id=4c78d5de&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__